import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class FlagFr extends PureComponent {
    static propTypes = {
        size: PropTypes.number
    };

    static defaultProps = {
        size: 16
    };

    render() {
        const { size } = this.props;
        return (
            <svg id="flag-icon-css-fr" viewBox="0 0 640 480" height={size}>
                <g fillRule="evenodd" strokeWidth="1pt">
                    <path fill="#fff" d="M0 0h640v480H0z" />
                    <path fill="#00267f" d="M0 0h213.3v480H0z" />
                    <path fill="#f31830" d="M426.7 0H640v480H426.7z" />
                </g>
            </svg>
        );
    }
}

export default withTheme(FlagFr);



// WEBPACK FOOTER //
// ./data/common/iconsvg/FlagFr.js